import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { BehaviorSubject, catchError, skip, map, Observable, of, timer, mergeMap, first } from "rxjs";
import { CaseTypeResponseModel } from "../models/case/case-type-response.model";
import { OutboundCasesService } from "../services/outbound-cases/outbound-cases.service";
import { Globals } from "../shared/globals/globals";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class CaseTypeInputValidator implements AsyncValidator {

  public newCase : BehaviorSubject<CaseTypeResponseModel> = new BehaviorSubject(null);

  constructor(private outboundCasesService : OutboundCasesService,
			  private globals : Globals,
			  private translate : TranslateService) { }

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {

    return timer(800).pipe(
      mergeMap(()=>{
        return this.outboundCasesService.getCaseByTypeCAndSubdivision(control.value,this.globals.user.warehouse.bkSubDivisionUidD).pipe(
          map(response =>{
            if(response && response.bkCaseTypeC && response.bkCaseTypeC != "") this.newCase.next(response);
            return response
          }),
          map(res => res.bkCaseTypeC ? null : {error : this.translate.instant('modal.invalidBox')}),
          catchError(err =>
            of(err).pipe(
              map(error => {
                this.newCase.next(null);
                return {notFound: error.error.failureList[0].message}
              })
            )
          )
        );
      })
    );

  }
}
